// extracted by mini-css-extract-plugin
export default {"disabledInputContainer":"disabledInputContainer___C66sn"};